import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { RecentPurchases } from './components/RecentPurchases';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  useEffect(() => {
    // Meta Pixel
    if (!(window as any).fbq) {
      const n = function (...args: any[]) {
        ;
        (n as any).callMethod ? (n as any).callMethod.apply(n, args) : (n as any).queue.push(args);
      };
      (n as any).push = n;
      (n as any).loaded = true;
      (n as any).version = '2.0';
      (n as any).queue = [];
      (window as any).fbq = n;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', '2411207615977952');
    (window as any).fbq('track', 'PageView');
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2411207615977952&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-matte selection:bg-gold selection:text-matte" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonosSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <RecentPurchases data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <ClosingSection data-id="element-10" />
    </div>;
}